module.exports = __webpack_public_path__ + "img/forbes-30-under-30.9d150c92.png";